module.exports = __webpack_public_path__ + "img/icon_jb.8734cbea.png";